import { normalizeCardPlayer } from './cardUtils';

export const SQUAD_REVEAL_KEY_PREFIX = 'squadRevealSeen:';

export const SQUAD_REVEAL_STAGES = Object.freeze({
  intro: 0,
  thirdBest: 1,
  secondBest: 2,
  tease: 3,
  walkout: 4,
  rest: 5,
  bestXi: 6,
});

function buildSeenKey(teamId) {
  return `${SQUAD_REVEAL_KEY_PREFIX}${teamId}`;
}

export function readSquadRevealSeen(teamId) {
  if (!teamId) return false;

  try {
    return localStorage.getItem(buildSeenKey(teamId)) !== null;
  } catch (error) {
    console.error('Failed to read the squad reveal flag from localStorage', error);
    return false;
  }
}

export function markSquadRevealSeen(teamId) {
  if (!teamId) return;

  try {
    localStorage.setItem(buildSeenKey(teamId), 'true');
  } catch (error) {
    console.error('Failed to save the squad reveal flag to localStorage', error);
  }
}

export function rankSquadPlayers(players = []) {
  return players
    .map((player, index) => ({
      player,
      normalized: normalizeCardPlayer(player),
      originalIndex: index,
    }))
    .sort((left, right) => {
      const leftOverall = left.normalized.overall;
      const rightOverall = right.normalized.overall;

      if (leftOverall === null && rightOverall !== null) return 1;
      if (leftOverall !== null && rightOverall === null) return -1;
      if (leftOverall !== rightOverall) return rightOverall - leftOverall;

      const nameOrder = left.normalized.name.localeCompare(
        right.normalized.name,
        undefined,
        { sensitivity: 'base' }
      );
      return nameOrder || left.originalIndex - right.originalIndex;
    });
}

export function shouldShowSquadReveal({ gameMode, isOwnTeam, players, seen }) {
  if (!['quickplay', 'multiplayer'].includes(gameMode)) return false;
  if (!isOwnTeam || seen || !Array.isArray(players) || players.length < 11) return false;

  return players.some((player) => normalizeCardPlayer(player).overall !== null);
}
